import h from "trader-hyperscript";

export function render(opts: null): HTMLElement | HTMLElement[] {
  return <span></span>;
}
